<script>
  export let people;

  let activeSort;

  let curAgency;

  function getAgencies() {
    let a = people.map((it) => it.agency_connection.split(", ")).filter((obj) => obj)
    a = [... new Set(a.flat())]
    return a.sort();
  }

  function sortByAlpha() {
    people = people.sort(function (a, b) {
      let aLastName = a.name.split(" ").pop();
      let bLastName = b.name.split(" ").pop();
      return aLastName.localeCompare(bLastName);
    });
    activeSort = "alpha";
  }

  function sortByAdded() {
    sortByAlpha()
    people = people.sort(function (a, b) {
      let aAdd = Date.parse(a.added)
      let bAdd = Date.parse(b.added)
      return bAdd - aAdd;
    });
    activeSort = "added";
  }

  function filterByAgency() {
    let listOffset = document.getElementById("person-list").offsetTop  
    let sorterHeight = document.getElementById("sorter").offsetHeight  
    let headerHeight = document.getElementsByClassName("site-header--compact")[0].offsetHeight
    console.log(listOffset - sorterHeight - headerHeight)
    window.scrollTo({top: listOffset - sorterHeight - headerHeight, behavior:"smooth"})
  }

  function matchAgency(str) {
    let res = str.split(", ").map((it) => it == curAgency).filter((obj) => obj)
    if (res.length > 0) return true
    return false;
  }

  function anchor(name) {
    return name.replace(/[^A-Za-z]/g, "-")
  }

  function s3Link(slug,suffix) {
    return `https://static.propublica.org/projects/doge-tracker/${slug}.${suffix}`
  }

  function humanDate(date) {
    const d = new Date(date + "T00:00:00")
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'America/New_York'
    };
    return d.toLocaleDateString('en-US', options).replace(/ /, '. ')
  }

  sortByAdded();
</script>

<div id="sorter">

  <div id="sorter-btn-grp" class="{activeSort}">
    <p class="sort-hed">Sort by</p>
    <div id="sort-btn-grp-inner">
      <div class="btn added" on:click={sortByAdded}>Added date</div>
      <div class="btn alpha" on:click={sortByAlpha}>Name</div>
    </div>
  </div>

  <div id="sorter-filter-grp">
    <p class="sort-hed">Filter by agency</p>
    <select bind:value={curAgency} on:change={filterByAgency}>
        <option value="">All agencies</option>
        {#each getAgencies() as agency}
          <option value={agency}>{agency}</option>
        {/each}
    </select>
  </div>
</div>

<div id="person-list">
{#each people as person}
  {#if !curAgency || matchAgency(person.agency_connection)}
    <div class="person" id="{anchor(person.name)}">
      <div class="hed-lockup{person.departed ? ' departed' : ''}">
        <div class="avi {person.img ? '' : 'no-image'}">
          {#if person.img}
            <img src={s3Link(person.img, "png")} />
          {:else}
            <img class="placeholder" src="{s3Link("id_badge_icon","svg")}" alt="placeholder avatar" />
          {/if}
        </div>

        <div class="name-title">
          <div class="name-lockup">
            <h3>{person.name}{#if person.age && person.age !== "Unknown"}<span class="age">, {person.age}</span>{/if}</h3>
            <div class="permalink">
              <a href="#{anchor(person.name)}">
              <img class="placeholder" src="{s3Link("link","svg")}" alt="permalink" />
              </a>
            </div>
          </div>

          {#if person.title !== "Unknown"}
            <h4>{person.title}</h4>
          {/if}

          {#if person.agency_connection && person.agency_connection !== "Unknown"}
            <h4 class='musk-connex-hed'>
              <strong>Connected to:</strong> {person.agency_connection}
            </h4>
          {/if}

          {#if person.musk_link}
            <h4 class='musk-connex-hed'>
              <strong>Musk link:</strong> {person.musk_link}
            </h4>
          {/if}

          {#if person.departed}
            <h4 class='departed-pill'>
              <strong>{person.departed}</strong>
            </h4>
          {/if}
          {#if person.fd}
            <h4 class='fd-pill'>
              <strong><a target="_blank" href="{person.fd}">Financial Disclosure</a></strong>
            </h4>
          {/if}
          {#if person.waiver}
            <h4 class='fd-pill'>
              <strong><a target="_blank" href="{person.waiver}">Ethics Waiver</a></strong>
            </h4>
          {/if}

        </div>
      </div>

      <div class="bio-wrapper">
        <p>{@html person.bio} </p>
        <p style="text-align:right;"><em>Added {humanDate(person.added)}</em></p>
      </div>
    </div>
  {/if}
{/each}
</div>